module.exports = __webpack_public_path__ + "static/media/delete-cross.f725734e.svg";